class snackbar {

    constructor(){
        this.snack=null;
        this.cssClass= 'snackbar';
        this.x= 0;
        this.y= 0;
        this.timeout= null;
        this.duration= 3000;
        this.closeable= false;
        this.message= '';
    }

    open (x=0, y=0, timeout = 2000, closeable = false) {
        this.snack = $('<div/>').addClass(this.cssClass);

        if(this.closeable){
            let snackAction = $('<div/>').addClass('snackbar-action');
            snackAction.html('<i class="fa fa-times"></i>');
            snackAction.on('click', () => {
                this.close();
            });
            this.snack.append(snackAction);
        }

        let snackContent = $('<div/>').addClass('snackbar-content');
        snackContent.html(this.message);
        this.snack.append(snackContent);

        this.timeout = setTimeout(()=>{this.close()}, this.duration);
        $('body').append(this.snack);
    }

    close () {
        this.snack.remove();
        clearTimeout(this.timeout);
    }

    primary(message) {
        this.cssClass+=' bg-primary';
        this.message = message;
        this.open();
    }
    secondary(message) {
        this.cssClass+=' bg-secondary';
        this.message = message;
        this.open();
    }
    success(message) {
        this.cssClass+=' bg-success';
        this.message = message;
        this.open();
    }
    info (message) {
        this.cssClass+=' bg-info';
        this.message = message;
        this.open();
    }
    warning (message) {
        this.cssClass+=' bg-warning';
        this.message = message;
        this.open();
    }
    danger(message) {
        this.cssClass+=' bg-danger';
        this.message = message;
        this.open();
    }
    light (message) {
        this.cssClass+=' bg-light';
        this.message = message;
        this.open();
    }
    dark (message) {
        this.cssClass+=' bg-dark';
        this.message = message;
        this.open();
    }
    white (message) {
        this.cssClass+=' bg-white';
        this.message = message;
        this.open();
    }
}

export default snackbar;
